import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { toast } from "sonner";

window.addEventListener("error", function (e) {
  if (
    e.error instanceof DOMException &&
    e.error.name === "DataCloneError" &&
    e.message &&
    e.message.includes("PerformanceServerTiming")
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    toast("New version available — refresh to update", {
      action: {
        label: "Refresh",
        onClick: () => {
          const waiting = registration && registration.waiting;
          if (waiting) {
            waiting.addEventListener("statechange", (e) => {
              if (e.target.state === "activated") window.location.reload();
            });
            waiting.postMessage({ type: "SKIP_WAITING" });
          } else {
            window.location.reload();
          }
        },
      },
      duration: Infinity,
    });
  },
});
